import React, { Fragment } from "react";
import styled from "styled-components";
import { IC } from "../../../resources/Assets";

const AvatarUser = (props) => {
  const { active, color } = props;

  return (
    <Fragment>
      <L_Icon>
        <L_Icon_Img src={IC.etc.ICON_USER_AVATAR_DEFAULT} />
        {active === true && <L_ICON_ACTIVE src={IC.etc.ICON_POINT_GREEN} />}
      </L_Icon>
    </Fragment>
  );
};

const L_Icon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 5.333px;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const L_Icon_Img = styled.img`
  flex-shrink: 0;
`;

const L_ICON_ACTIVE = styled.img`
  position: absolute;
  right: -5px;
  bottom: -8px;
`;

export default AvatarUser;
